import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { NotFoundComponent } from './views/error-pages/not-found/not-found.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./views/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'contact-info',
    loadChildren: () =>
      import('./views/contact-info/contact-info.module').then(
        (m) => m.ContactInfoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'address-info',
    loadChildren: () =>
      import('./views/address-info/address-info.module').then(
        (m) => m.AddressInfoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./views/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'prescription',
    loadChildren: () =>
      import('./views/prescription/prescription.module').then(
        (m) => m.PrescriptionModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'checkout',
    loadChildren: () =>
      import('./views/checkout/checkout.module').then((m) => m.CheckoutModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'orders',
    loadChildren: () =>
      import('./views/orders/orders.module').then((m) => m.OrdersModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'sign-out',
    loadChildren: () =>
      import('./views/sign-out/sign-out.module').then((m) => m.SignOutModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'telehealth-consent',
    loadChildren: () =>
      import('./views/telehealth-consent/telehealth-consent.module').then(
        (m) => m.TelehealthConsentModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./views/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'impersonate',
    loadChildren: () =>
      import('./views/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'sign-up',
    loadChildren: () =>
      import('./views/sign-up/sign-up.module').then((m) => m.SignUpModule),
  },
  {
    path: 'benefits',
    loadChildren: () =>
      import('./views/benefits/benefits.module').then((m) => m.BenefitsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./views/profile/profile.module').then((m) => m.ProfileModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'policies',
    loadChildren: () =>
      import('./views/policies/policies.module').then((m) => m.PoliciesModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'products/safety-eyewear',
    loadChildren: () =>
      import('./views/products/safety-eyewear/safety-eyewear.module').then(
        (m) => m.SafetyEyewearModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'products/computer-eyewear',
    loadChildren: () =>
      import('./views/products/computer-eyewear/computer-eyewear.module').then(
        (m) => m.ComputerEyewearModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'products/dress-eyewear',
    loadChildren: () =>
      import('./views/products/dress-eyewear/dress-eyewear.module').then(
        (m) => m.DressEyewearModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'products/safety-shoes',
    loadChildren: () =>
      import('./views/products/safety-shoes/safety-shoes.module').then(
        (m) => m.SafetyShoesModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'products/shoe-insoles',
    loadChildren: () =>
      import('./views/products/shoe-insoles/shoe-insoles.module').then(
        (m) => m.ShoeInsolesModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'products/respirators',
    loadChildren: () =>
      import('./views/products/respirators/respirators.module').then(
        (m) => m.RespiratorsModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'cart',
    loadChildren: () =>
      import('./views/cart/cart.module').then((m) => m.CartModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'lens-selection',
    loadChildren: () =>
      import('./views/lens-selection/lens-selection.module').then(
        (m) => m.LensSelectionModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
